import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../core/layout/components/abstracts/base.component';
import { heightDirective } from '../../directives/height.directive';

@Component({
  selector: 'app-chip',
  standalone: true,
  imports: [
    heightDirective
  ],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChipComponent extends BaseComponent {

  @Input({ required: true }) value: number | string;
  @Input({ required: true }) label: string;
  @Input({ required: true }) selected: boolean;
  @Input({ required: true }) disabled: boolean;
  @Input() withIcon = true;
  @Input() suffixIcon?: string;
  @Input() suffixIconClass?: string;

  @Output() onClick = new EventEmitter<number | string>();
}
